import React from "react";
import "./ThemeLoader.scss";

type ThemeLoaderSize = "default" | "compact";

interface ThemeLoaderProps {
  size?: ThemeLoaderSize;
}

export const ThemeLoader: React.FC<ThemeLoaderProps> = ({
  size = "default",
}) => (
  <div
    className={`theme-loader theme-loader--${size}`}
    role="status"
    aria-label="Загрузка"
  >
    <div className="theme-loader__spinner" />
  </div>
);
